import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';


export class AppModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [],
  imports: [
    CommonModule
  ],
  exports: []
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
